import { RemoveCircleIcon } from 'app/common/icons'
import { BaseRow } from 'app/components/common/BaseRow'
import { FONT_WEIGHT, PADDING, colors } from 'parkway-web-common'
import styled from 'styled-components'

export const SkillWrapper = styled(BaseRow)`
  justify-content: space-between;
  display: flex;
  padding: 8px;
  border-radius: 20px;
  background-color: #f8f8f8;
  gap: 8px;
`

export const LevelTag = styled.div<{ color?: string }>`
  padding: 4px ${PADDING.xxxxs};
  border-radius: 20px;
  color: ${colors.white};
  background-color: ${props => (props.color ? props.color : colors.grayC4)};
  font-size: ${PADDING.xxxs};
  font-weight: ${FONT_WEIGHT.bold};

  &::before {
    content: '•';
    font-size: 100%;
    margin-right: 4px;
    font-weight: ${FONT_WEIGHT.black};
  }
`

export const SkillTitle = styled.div``

export const RemoveCircleIconStyled = styled(RemoveCircleIcon)`
  cursor: pointer;
`

export const LevelTagGroup = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
`
